<div class="cart-confirmation-bdp content d-flex position-relative">
    <app-sprintpay-confirmation class="position-absolute"> </app-sprintpay-confirmation>
</div>
